import { Input, message, Pagination, Result, Select, Statistic } from 'antd';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Link, useHistory, useParams } from 'react-router-dom';
// import { Link, useParams } from 'react-router-dom'
// import { AiOutlineSearch } from 'react-icons/ai';
import { AiOutlineLeft } from 'react-icons/ai';
// import CampaignCardComponent from '../../components/Brand/Campaign/CampaignCardComponent'
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { useGlobalState } from '../../store/state';
// import { CampaignDelete } from '../../apis/Brand/Campaigns/CampaignDelete';
// import { CampaignList } from '../../apis/Brand/Campaigns/CampaignList';
import CurrencyIcon from '../../components/Common/CurrencyIcon';
import { CampaignGetSingle } from '../../apis/Brand/Campaigns/CampaignGetSingle';
import ProgressCardComponent from '../../components/Brand/Campaign/Overview/ProgressCardComponent';
import './BrandStatsDetailPage.styles.scss';
import CampProgressComponent from '../../components/Brand/Campaign/Overview/CampProgressComponent';
import { SyncCampiagnData } from '../../utils/SyncCampiagnData';
import { CampaignCalculator } from '../../apis/Brand/Campaigns/CampaignCalculator';
import { checkObjectKeyValues, dateDiffFinder, numberToShortFormat } from '../../utils';
import { CampaignOverview } from '../../apis/Brand/Campaigns/CampaignOverview';
import PlatformIconRender from '../../components/Common/PlatformIconRender';
import ReachStatsComponent from '../../components/Brand/Campaign/Overview/ReachStatsComponent';
import InfluencerCardComponent from '../../components/Brand/InfluencerList/InfluencerCardComponent';
import EmptyInfluencerComponent from '../../components/Brand/InfluencerList/EmptyInfluencerComponent';
import InsightsStatsComponent from '../../components/Brand/Campaign/Overview/InsightsStatsComponent';
import { CampaignTopInfluencers } from '../../apis/Brand/Campaigns/CampaignTopInfluencers';
import SocialPostComponent from '../../components/Influencers/Profile/SocialPostComponent';
import { getCampaignTopPosts } from '../../apis/Brand/Campaigns/CampaignTopPosts';

const BrandStatsDetailPage = () => {
  const history = useHistory();
  const params = useParams();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [create_camp_draft] = useGlobalState('create_camp_draft');
  const [campDefSet] = useGlobalState('campDefSet');
  // const [user] = useGlobalState('user')
  const [campData, setCampData] = useState({});
  const [calcData, setCalcData] = useState({});
  const [overviewData, setOverviewData] = useState({});
  const [topInflus, setTopInflus] = useState([]);
  const [topPosts, setTopPosts] = useState([]);


  // note: get campaign caluclated data details
  const calculatedData = (currentData) =>{
    // console.log("ddata",currentData)
    SyncCampiagnData(
      create_camp_draft, // store sync object
      company.selected.id, // active company id
      campDefSet, // default field set for pre filter
      {
        campaignid: params.campaignid,
        data: checkObjectKeyValues(currentData), // prepared data or existing data
        returnOnly: true, // this option used to get data back only instead of sync in store
      }, // updated set of data to process
    ).then((data)=>{
      // @note: preparing data to calculate
      const _data = {
        ...data, // all existing data
        startdate: moment(data.startdate).valueOf(), // converting startdate to milliseconds
        enddate: moment(data.enddate).valueOf(), // converting enddate to milliseconds
      };
      CampaignCalculator(user.accessToken, checkObjectKeyValues(_data)).then(({ status, response })=>{
        console.log('calulated', response);
        if (status === 200) {
          setCalcData({
            ...calcData,
            ...response,
          });
        } else {
          // console.log("calulator error", response)
          // message.error("There some issue while calulating")
        }
      });
    });
  };


  useEffect(() =>{
    CampaignGetSingle(user.accessToken, params.campaignId).then(({ status, response }) =>{
      console.log('response from view camp==>', response);
      if (status === 200) {
        // let _tcreatives = response.deliverables.reduce((prev,next) => prev + next.creatives,0)
        setCampData({
          ...campData,
          ...response,
          // addon to this component
          totalCreatives: response.deliverables.reduce((prev, next) => prev + next.creatives, 0) || 'N/A',
        });

        // get
        calculatedData(response);
      } else {
        // loadDeafultCreation();
        message.error('There some issue with gettting your Campaign data');
      }
      // setDraftData(true)
    });

    CampaignOverview(user.accessToken, params.campaignId).then(({ status, response }) =>{
      if (status === 200) {
        console.log('camp over api', response);
        setOverviewData(response);
      }
    });
    CampaignTopInfluencers(user.accessToken, params.campaignId).then(({ status, response }) =>{
      if (status === 200) {
        response.sort((a, b) => {
          if (a && a.social) {
            if (b && b.social) {
              return a.social.likes > b.social.likes;
            } else {
              return -1;
            }
          } else {
            return 1;
          }
        });
        setTopInflus(response);
      }
    });
    getCampaignTopPosts(user.accessToken, params.campaignId).then(({ status, response }) =>{
      if (status === 200) {
        response.sort((a, b) => {
          console.log('a', a);
          return a.like_count > b.like_count;
        });
        setTopPosts(response);
      }
    });
  }, []);
  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="py-2 sticky stat_over_header">
        <div className="d-flex flex-wrap">
          <div className="col-12">
            <h5 className="m-0 stat_over_header_title">
              <a className="stat_over_header_title--back"
                onClick={history.goBack}>
                <AiOutlineLeft/>
              </a>
              <span>{campData.name || 'N/A'}</span>
            </h5>
          </div>
        </div>
      </BrandTopSubHeaderComponent>
      <div style={{ padding: 15 }}>
        <div className="campaign_cards">
          <div className="row">
            <div className="col-md-12">
              <div className="pt-1 pb-2">
                <h6>Campaign Overview</h6>
              </div>
            </div>
          </div>
          <div className="row h-100">
            <div className="col-md-6 pr-2">
              {
                Object.keys(campData).length && <ProgressCardComponent
                  objective={campData.objective}
                  status={campData.campaignstatus}
                  platform={campData.platform}
                  created={campData.createdAt}
                  campaignid={campData.id}
                />
              }
              {
                Object.keys(overviewData).length ?
                  <CampProgressComponent
                    influencers={{
                      current: parseInt(overviewData.totalinfluencers),
                      expected: parseInt(overviewData.targetInfluencers),
                    }}
                    reach={{
                      current: parseInt(overviewData.currentreach),
                      expected: parseInt(overviewData.estimatedReach),
                    }}
                    views={{
                      current: parseInt(overviewData.totalviews),
                      expected: parseInt(overviewData.targetviews),
                    }}
                  /> :
                  null
              }
            </div>
            <div className="col-md-6 pl-2">
              <div className="d-flex flex-column">
                <div className="col-12 px-0 mb-2">
                  <div className="row">
                    <div className="col-6 pr-2">
                      <div className="common_card  text-center">
                        <div className="campaign_cards_extras--each py-4">
                          <h4>{overviewData.engagementrate || 'N/A'}</h4>
                          {/* <h4>{calcData.avgEngagementRate + "%" || 'N/A'}</h4> */}
                          <p>Avg. Engagement Rate</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-6 pl-2">
                      <div className="common_card text-center">
                        <div className="campaign_cards_extras--each py-4">
                          <h4>{numberToShortFormat(parseInt(overviewData.estimatedReach)) || 'N/A'}</h4>
                          {/* <h4>{numberToShortFormat(parseInt(calcData.influencers)) || 'N/A'}</h4> */}
                          <p>Estimated Reach</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 px-0 mt-2">
                  <div className="common_card p-3">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="campaign_cards_extras_costs">
                          <p>Campaign Cost</p>
                          <h5 className="my-5">
                            <span>CREDIT</span>
                            {CurrencyIcon()} <Statistic className="custom_number_format"
                              value={campData.budget || 'N/A'}/>
                          </h5>
                        </div>
                      </div>
                      <div className="col-md-8">
                        <ul className="campaign_cards_extras_gens">
                          <li>
                            <h6>{overviewData.currentreach}</h6>
                            <p>Influencers Reach</p>
                          </li>
                          {/* <li>
                                                        <h6>{
                                                            calcData.numberofdays
                                                        }</h6>
                                                        <p>No.of Days</p>
                                                    </li> */}
                          <li>
                            <h6>{
                              dateDiffFinder(campData.startdate, campData.enddate)
                            }</h6>
                            <p>No.of Days</p>
                          </li>
                          <li>
                            <h6>{campData.deliverables && campData.deliverables.length}</h6>
                            <p>Total Creatives</p>
                          </li>
                          {/* <li>
                                                        <h6>{campData.totalCreatives}</h6>
                                                        <p>Creative Types</p>
                                                    </li> */}
                          <li>
                            <h6>{overviewData.totalposts}</h6>
                            <p>Total Posts</p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <ReachStatsComponent
                engagementrate={overviewData.engagementrate}
                totalreach={overviewData.estimatedReach}
                reachData={overviewData?.insights?.reach || []}
              />
            </div>
            <div className="col-md-12">
              <InsightsStatsComponent
                engagementrate={overviewData.engagementrate}
                totalreach={overviewData.totalreach}
                reachData={overviewData.reach}
                insightsData={overviewData.insights}
              />
            </div>
            <div className="col-md-12">
              <div className="common_card mt-3 over_progress_multi p-3">
                <h6 className="pb-2"><strong>Top Posts</strong></h6>
                <div className="d-flex pb-2">
                  {topPosts && topPosts.length ?
                    topPosts.map((post) =>(
                      <div className='mr-4'>
                        <SocialPostComponent post={post}
                          fetchInsights = {false}/>
                      </div>
                    )):
                    <EmptyInfluencerComponent>No posts found</EmptyInfluencerComponent>
                  }
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="common_card mt-3 over_progress_multi p-3">
                <h6 className="pb-2"><strong>Top Influencers</strong></h6>
                <div className="d-flex pb-2">
                  {topInflus && topInflus.length ?
                    topInflus.map((influencer) =><InfluencerCardComponent
                      key={influencer._id}
                      // allowAddList
                      firstname={influencer?.firstname}
                      id={influencer._id}
                      lastname={influencer?.lastname}
                      username={influencer?.influencersocialAccount?.[0]?.username}
                      followers={influencer?.influencersocialAccount?.[0]?.followingSubscribers}
                      postsCount={influencer?.influencersocialAccount?.[0]?.posts}
                      country={influencer?.country}
                      profile_pic={influencer?.influencersocialAccount?.[0]?.profilepic}
                      interests={influencer?.interests}
                      allowProfileBtn
                      platform={influencer.platform}/> ):
                    <EmptyInfluencerComponent>No influencers found</EmptyInfluencerComponent>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrandBaseLayoutComponent>
  );
};

export default BrandStatsDetailPage;
